import React from 'react';

import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import StatusSchedulesLogs from 'scenes/Gallery/GalleryPage/Concepts/components/StatusSchedulesLogs';
import { archiveConcept } from 'scenes/Gallery/GalleryPage/Concepts/sources/concepts';
import CustomBodyText from 'scenes/Gallery/components/CustomBodyText';

import { archive } from '../queryKeyFactory';

export const useArchive = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const removeMutation = useMutation(archive(), archiveConcept, {
    successMessage: () => `Concept was archived`,
  });

  const handleAction = async ({ id, name, stateSchedules }) => {
    if (stateSchedules?.length > 1) {
      await showModal({
        title: 'Change Status Warning',
        bodyText: `Concept “${name}” status schedule will be permanently removed.`,
        children: <StatusSchedulesLogs data={stateSchedules} />,
        confirmActionLabel: 'Change',
      });
    } else {
      await showModal({
        title: 'Archive Concept?',
        confirmActionLabel: 'Archive',
        bodyText: <CustomBodyText name={name} />,
      });
    }
    await removeMutation.mutateAsync({ ids: [id] });
  };

  return [handleAction, removeMutation];
};
